import Color from 'library/components/color';
import { InputPlaceholder, ErrorContainer } from 'library/styles/text';
import {
  StyledInput,
  Container,
  Icon,
  ColorIcon,
  StyledColors,
  MoreColors,
  MoreImagesMarker,
} from './styles';

const Input = ({
  error,
  inputRef,
  isDirty,
  iconClassName,
  isLoading = false,
  isColorField = false,
  isSetField = false,
  formatterMap,
  ...props
}) => {
  const renderColors = (data) => {
    const total = data.length;
    const limitedData = data.slice(0, 7);
    const totalDisplayed = limitedData.length;

    if (total) {
      return (
        <>
          {limitedData.map((value) => <Color color={`${value.includes('#') ? '' : '#'}${value}`} key={`color-${value}`} />)}
          {total > totalDisplayed ? (
            <MoreColors>
              +
              {total - totalDisplayed}
            </MoreColors>
          ) : null}
        </>
      );
    }

    return <InputPlaceholder>{props.placeholder}</InputPlaceholder>;
  };

  const renderSets = (data) => {
    if (data.length) {
      return (
        <>
          {
            data.slice(0, 2)
              .map((id) => formatterMap[id]).join(', ')
          }
          &nbsp;&nbsp;&nbsp;&nbsp;
          {(data || []).length > 2 ? (
            <MoreImagesMarker>
              +
              {data.length - 2}
            </MoreImagesMarker>
          ) : null}
        </>

      );
    }

    return <InputPlaceholder>{props.placeholder}</InputPlaceholder>;
  };

  return (
    <Container isLoading={isLoading}>
      {isColorField ? <ColorIcon className={iconClassName} /> : <Icon className={isLoading ? 'icon-loader' : iconClassName} />}
      {
        isColorField && (
          <StyledColors
            onClick={props.onClick}
            readOnly={isLoading ? true : props.readOnly}
            disabled={props.disabled}
          >
            {renderColors(props.value || [])}
          </StyledColors>
        )
      }

      {
        isSetField && (
          <StyledColors
            onClick={props.onClick}
            readOnly={props.readOnly}
            disabled={props.disabled}
          >
            {renderSets(props.value || [])}
          </StyledColors>
        )
      }

      {
        !isColorField && !isSetField && (
          <>
            <StyledInput
              {...props}
              value={(formatterMap && formatterMap[props.value]) ? formatterMap[props.value] : props.value}
              hasError={isDirty && Boolean(error?.message)}
              isLoading={isLoading}
              onBlur={isLoading ? undefined : props.onBlur}
              onWheelCapture={(e) => {
                e.target.blur();
              }}
              readOnly={isLoading ? true : props.readOnly}
              isFocusDisabled={Boolean(props.onClick)}
            />
          </>
        )
      }

      {error ? <ErrorContainer>{error.message}</ErrorContainer> : null}
    </Container>
  );
};

export default Input;
